export default __webpack_public_path__ + "static/media/blue-round.dcd3ecac.svg";